export default function CardTitle({ text }: { text: string }) {
    return (
        <h1 className="text-xl font-bold">{text}</h1>
    )
}